import React from 'react'
import styled from 'styled-components'
import { backgroundColors } from 'config'

import Label from 'components/Label'

const Radio = ({ handleSelection, ...props }) => {
  return (
    <Li onClick={() => handleSelection()} bgColor={backgroundColors.normalLeft}>
      <Input
        bgColor={backgroundColors.normalLeft}
        id={`opt-${props.value}-${props.text}`}
        name={props.name}
        checked={props.selected}
        onChange={(e) => {
          handleSelection()
        }}
      />
      <StyledLabel for={`opt-${props.value}-${props.text}`}>
        {props.text}
      </StyledLabel>
      <Check />
    </Li>
  )
}

export default class RadioGroup extends React.Component {
  render() {
    const { items, onSelectionChange, value } = this.props

    return (
      <Container>
        {items &&
          items.map((item, index) => {
            return (
              <Radio
                key={`radiogroupitem-${item.value}${item.text}`}
                name={this.props.name}
                handleSelection={() => onSelectionChange(item)}
                value={item.value}
                text={item.text}
                selected={item.value === value}
              />
            )
          })}
      </Container>
    )
  }
}

export { Radio }

const Container = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  overflow: auto;
  width: auto;
  display: inline-block;
  margin-top: 23px;
`

const Li = styled.li`
  display: block;
  position: relative;
  float: left;

  @media (max-width: 980px) {
    float: initial;
  }

  &:hover {
    div {
      background: ${({ bgColor }) => bgColor};
      &::before {
        background: #ffffff;
      }
    }
  }

  &:before,
  &:after {
    content: '';
    display: table;
  }

  &:after {
    clear: both;
  }

  & + & {
    margin-left: 32px;

    @media (max-width: 980px) {
      margin-left: 0;
    }
  }

  zoom: 1;
`

const Input = styled.input.attrs({
  type: 'radio',
})`
  display: block;
  position: absolute;
  width: 14px;
  height: 14px;
  visibility: hidden;
  z-index: 6;

  &:checked {
    ~ div {
      background: ${({ bgColor }) => bgColor};
      &::before {
        background: #ffffff;
      }
    }
  }
`

const Check = styled.div`
  display: block;
  position: absolute;
  width: 14px;
  height: 14px;
  border: 1px solid #9c9c9c;
  background-color: #ffffff;
  top: 8px;
  left: 0px;
  border-radius: 100%;
  z-index: 5;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  &::before {
    display: block;
    content: '';
    border-radius: 100%;
    height: 6px;
    width: 6px;
    background: #ffffff;
  }
`

const StyledLabel = styled(Label)`
  font-size: 12px;
  font-weight: bold;
  line-height: 12px;
  text-align: center;
  margin: 10px auto;
  padding-left: 19px;
  cursor: pointer;
  z-index: 9;
  @media (max-width: 768px) {
    text-align: left;
  }
`



// WEBPACK FOOTER //
// ./src/components/RadioGroup/index.js